export const fileTypeFromFileName = (fileName: string): string => {
    const extension = fileName.split('.').pop();
    switch (extension) {
        case 'jpg':
            return 'image/jpg';
        case 'jpeg':
            return 'image/jpeg';
        case 'png':
            return 'image/png';
        case 'gif':
            return 'image/gif';
        case 'bmp':
            return 'image/bmp';
        case 'mp4':
            return 'video/mp4';
        case 'webm':
            return 'video/webm';
        case 'ogg':
            return 'video/ogg';
        case 'mov':
            return 'video/quicktime';
        case 'avi':
            return 'video/x-msvideo';
        case 'wmv':
            return 'video/x-ms-wmv';
        case 'pdf':
            return 'application/pdf';
        case 'zip':
            return 'application/zip';
        case 'doc':
        case 'docx':
            return 'application/msword';
        case 'xls':
        case 'xlsx':
            return 'application/vnd.ms-excel';
        case 'txt':
            return 'text/plain';
        default:
            return 'file';
    }
};
